import { useState } from "react";
import api from "../../../shared/utils/request";
import toast from "react-hot-toast";

const addToCart = async (
  product,
  quantity = 1,
  productId,
  productVariantId,
  setLoading,
) => {
  const isToken = localStorage.getItem("token");
  if (!isToken) {
    window.showLoginModal?.();
    return;
  } else {
    try {
      setLoading?.(true);
      const data = await api.post(`customer/addToCart`, {
        product_id: productId,
        product_variant_id: productVariantId,
        quantity: quantity,
        price: product.price,
      });
      if (data?.status === true) {
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }
      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);
      console.error("Failed to add product to cart:", error);
    }
  }
};

const AddToCartSmall = ({ product }) => {
  const [addToCartLoading, setAddToCartLoading] = useState(false);

  return (
    <>
      <span
        onClick={() =>
          addToCart(
            product,
            1,
            product.id,
            product.variant_id,
            setAddToCartLoading,
          )
        }
        className={`product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16 ${addToCartLoading ? "opacity-50 pe-none" : ""}`}
        key={"small-cart-" + product.variant_id}
        style={
          addToCartLoading ? { cursor: "not-allowed" } : { cursor: "pointer" }
        }
      >
        Add
        {addToCartLoading ? (
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        ) : (
          <i className="ph ph-shopping-cart" />
        )}
      </span>
    </>
  );
};

const AddToCartFullText = ({ product }) => {
  const [addToCartLoading, setAddToCartLoading] = useState(false);

  return (
    <span
      key={"full-text-cart-" + product.variant_id}
      onClick={() =>
        addToCart(
          product,
          1,
          product.id,
          product.variant_id,
          setAddToCartLoading,
        )
      }
      className={`product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center ${addToCartLoading ? "opacity-50 pe-none" : ""}`}
      style={
        addToCartLoading ? { cursor: "not-allowed" } : { cursor: "pointer" }
      }
    >
      Add To Cart
      {addToCartLoading ? (
        <span
          class="spinner-border spinner-border-sm"
          aria-hidden="true"
        ></span>
      ) : (
        <i className="ph ph-shopping-cart" />
      )}
    </span>
  );
};

const AddToCartSinglePage = ({ product }) => {
  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);

  return (
    <>
      <span className="pt-10 text-gray-700 border-top border-gray-100 d-block" />
      <span className="text-gray-900 d-block mb-8">Quantity:</span>
      <div className="flex-between gap-16 flex-wrap">
        <div className="flex-align flex-wrap gap-16">
          <div className="border border-gray-100 rounded-pill py-9 px-16 flex-align">
            <button
              type="button"
              disabled={quantity <= 1}
              className="quantity__minus p-4 text-gray-700 hover-text-main-600 flex-center"
              onClick={() => setQuantity((prev) => prev - 1)}
            >
              <i className="ph ph-minus" />
            </button>
            <input
              type="number"
              className="quantity__input border-0 text-center w-32"
              value={quantity}
            />
            <button
              type="button"
              disabled={product?.stock <= quantity}
              className="quantity__plus p-4 text-gray-700 hover-text-main-600 flex-center"
              onClick={() => setQuantity((prev) => prev + 1)}
            >
              <i className="ph ph-plus" />
            </button>
          </div>
          <button
            onClick={() =>
              addToCart(
                product,
                quantity,
                product.product_id,
                product.id,
                setAddToCartLoading,
              )
            }
            className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48"
            disabled={product?.stock <= quantity || addToCartLoading}
          >
            {addToCartLoading ? (
              <span
                class="spinner-border spinner-border-sm"
                aria-hidden="true"
              ></span>
            ) : (
              <>
                <i className="ph ph-shopping-cart" />
              </>
            )}
            Add To Cart
          </button>
        </div>
        <div className="flex-align gap-12">
          <a
            href="#"
            className="w-52 h-52 bg-main-50 text-main-600 text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle"
          >
            <i className="ph ph-heart" />
          </a>
        </div>
      </div>
    </>
  );
};

export default { AddToCartSmall, AddToCartFullText, AddToCartSinglePage };
